<template>
  <div>
    <p class="d-flex justify-center font-weight-bold  mt-4">
      {{ $t("message.common.started_job", { job: $t("message.job.job_type_" + command_type) } ) }}</p>
    <v-icon color="primary" class="d-flex justify-center" size="60">mdi-check-circle</v-icon>
    <div class="mt-8 mb-1 mx-1">
      <template v-if="$slots.title">
        <slot name="title" />
      </template>
      <v-data-table
        :headers="headers"
        :items="jobs"
        :items-per-page="-1"
        hide-default-footer
        class="elevation-1 mt-1 data-table"
        @click:row="$event.jid != null ? $router.push('/' + get_prefix() + 'job/' + $event.jid) : ''"
      >
        <template v-slot:item.jid="{ item }">
          <template v-if="item.jid == null">
            -
          </template>
          <template v-else>
            {{ item.jid }}
          </template>
        </template>
        <template v-slot:item.name="{ item }">
          <template v-if="item.name.length <= 40">
            {{ item.name }}
          </template>
          <template v-else>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <span v-on="on">
                  {{ item.name.substr(0, 40) }}...
                </span>
              </template>
              <span>{{ item.name }}</span>
            </v-tooltip>
          </template>
        </template>
        <template v-slot:item.status="{ item }">
          <span :class="status_color[item.status]">{{ $t('message.complete.status_' + item.status) }}</span>
        </template>
      </v-data-table>
    </div>
    <template v-if="show_link">
      <v-card flat class="d-flex justify-end pt-5">
        <p>
          <v-btn x-large @click="moveLink()" color="primary" class="btn">
            {{ $t("message.complete.result", { type: $t("message.job.job_type_"+ command_type) }) }}
          </v-btn>
        </p>
        <p class="text-right ml-3">
          <v-btn x-large to="/">
            {{ $t("message.common.return_home") }}
          </v-btn>
        </p>
      </v-card>
    </template>
    <p v-if="takes_time" class="text-right mt-0">{{ $t("message.complete.info", { type: $t("message.job.job_type_"+ command_type) }) }}</p>
  </div>
</template>

<script>
  import { res_list } from "../js/res_list";

  export default {
    name: 'complete',
    mixins: [res_list],
    props: {
      command_type: String,
      jobs: Array,
      mode: String,
      takes_time: Boolean,
      show_link: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        module_id: "XX",
        headers: [{
            text: this.$i18n.t("message.common.jid"),
            value: 'jid',
            sortable: false
          },
          {
            text: this.$i18n.t("message.common.title"),
            value: 'name',
            sortable: false
          },
          {
            text: this.$i18n.t("message.common.status"),
            value: 'status',
            sortable: false
          },
        ],
        status_color: {
          "complete": "lime--text",
          "error": "red--text",
          "uploading": "",
        }
      }
    },
    methods: {
      moveLink() {
        const fileType = {
          translate: {
            'route': '/file',
            'type': 'translated'
          },
          train: {
            'route': '/model',
          },
          similarity: {
            'route': '/file',
            'type': 'source'
          },
          estimate: {
            'route': '/file',
            'type': 'source'
          },
          corpus_import: {
            'route': '/corpus'
          }
        }
        const route = fileType[this.command_type]['route'];
        if(!!fileType[this.command_type]['type']){
          this.$router.push({ path: route, query: { file_type: fileType[this.command_type]['type'] }})
        }else {
          this.$router.push({ path: route });
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  .btn {
    min-width: 187px;
  }
</style>
